<div class="flex flex-col gap-3">
    <p-iconfield>
        <p-inputicon styleClass="pi pi-search" />
        <input pInputText type="text" placeholder="Buscar por nome, apelido ou CPF (só números, mín. 2 caracteres)..." [(ngModel)]="termoBusca" (ngModelChange)="onTermoChange($event)" class="w-full" />
    </p-iconfield>

    @if (carregando()) {
        <div class="flex justify-center py-4">
            <i class="pi pi-spin pi-spinner text-2xl text-muted-color"></i>
        </div>
    }

    @if (!carregando() && buscaRealizada()) {
        <p-table [value]="resultados()" styleClass="p-datatable-sm" [scrollable]="true" scrollHeight="300px">
            <ng-template pTemplate="header">
                <tr>
                    <th>Nome</th>
                    <th>Apelido</th>
                    <th>UF</th>
                    <th class="text-center">Status SAS</th>
                    <th class="text-center">Ação</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-item>
                <tr [class.opacity-50]="item.jaVinculado">
                    <td>
                        {{ item.nmSolicitante }}
                        @if (rotuloEstado(item); as rotulo) {
                            <small class="block text-muted-color">{{ rotulo }}</small>
                        }
                    </td>
                    <td class="font-mono text-sm">{{ item.apelido || '—' }}</td>
                    <td>{{ item.sgUf }}</td>
                    <td class="text-center">
                        @if (item.inStatus) {
                            <p-tag [severity]="statusSas(item.inStatus)" [value]="labelStatusSas(item.inStatus)" />
                        } @else {
                            <span class="text-muted-color">—</span>
                        }
                    </td>
                    <td class="text-center">
                        @if (item.jaVinculado) {
                            <span class="text-xs text-muted-color">Já vinculado</span>
                        } @else {
                            <p-button label="Selecionar" size="small" (onClick)="selecionar(item)" />
                        }
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="5" class="text-center text-muted-color py-4">Nenhum usuário encontrado para "{{ termoBusca }}".</td>
                </tr>
            </ng-template>
        </p-table>
    }
</div>
